import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { rotateSessionOnAuth, trackProductEvent } from "@/lib/productAnalytics";

export function ProductAnalytics() {
  const location = useLocation();
  const { user } = useAuth();
  const lastUserIdRef = useRef<string | null>(null);

  // Track page views (first-party)
  useEffect(() => {
    void trackProductEvent("page_view", undefined, {
      userId: user?.id ?? null,
      path: location.pathname + location.search,
    });
  }, [location.pathname, location.search, user?.id]);

  // Rotate session boundary on auth changes (anonymous -> authenticated)
  useEffect(() => {
    const currentUserId = user?.id ?? null;
    if (lastUserIdRef.current !== currentUserId) {
      rotateSessionOnAuth(currentUserId);
      lastUserIdRef.current = currentUserId;
    }
  }, [user?.id]);

  return null;
}
